import "./print-elements.css";
import BackCoverSvg from "../../svgs/back-cover";

const BackCover = () => {
  return (
    <div className="coverPage backCover">
      <BackCoverSvg />
    </div>
  );
};

export default BackCover;
